const messages = {
    menuTitle: 'Zgłaszanie awarii',
    pageTitle: 'Zgłaszanie awarii',
    accidents: {
        list: {
            pageTitle: 'Zgłaszanie awarii / Lista awarii',
            actions: {
                create: 'Zgłoś awarię',
                generateReport: 'Generuj raport',
                dashboard: 'DASHBOARD'
            },
            filters: {
                showNotAccepted: 'Pokaż niezatwierdzone',
                hideSolved: 'Ukryj rozwiązane',
                showMine: 'Pokaż moje',
                machine: 'Maszyna',
                productionDepartment: 'Dział produkcyjny',
                softwareType: 'Oprogramowanie',
                status: 'Status',
                department: 'Działy awarii',
                lastAssignee: 'Osoba ostatnio przypisana',
                createdFrom: 'Data utworzenia od:',
                createdTo: 'Data utworzenia do:',
                type: 'Typ',
                solvedFrom: 'Data usunięcia od:',
                solvedTo: 'Data usunięcia do:',
                costCenterNumber: 'MPK'
            },
            usersSearch: {
                searching: 'Trwa wyszukiwanie...',
                emptyPrompt: 'Wpisz treść aby odnaleźć użytkownika.',
                noResults: 'Nie znaleziono'
            },
            tooltips: {
                assignToMe: 'Przypisz do mnie',
                accept: 'Zatwierdź',
                history: 'Historia',
                generateQrCode: 'Generuj kod QR',
                edit: 'Edytuj',
                delete: 'Usuń'
            },
            dialogs: {
                assignToMe: {
                    title: 'Przypisanie awarii #{id}',
                    content: 'Czy na pewno chcesz przypisać awarię do siebie?'
                },
                delete: {
                    title: 'Usuwanie awarii #{id}',
                    content: 'Czy na pewno usunąć nierozwiązaną awarię?'
                }
            },
            notifications: {
                acceptSuccess: 'Awaria została zatwierdzona.'
            },
            table: {
                headers: {
                    id: 'ID',
                    machineOrSoftware: 'Maszyna/Oprogramowanie',
                    createdAt: 'Data utworzenia',
                    status: 'Status',
                    type: 'Typ',
                    department: 'Dział',
                    creator: 'Zgłaszający',
                    lastAssignee: 'Prowadzący',
                    adminAccepted: 'Czy zatwierdzona'
                }
            }
        },
        dashboard: {
            pageTitle: 'Zgłaszanie awarii / Dashboard awarii',
            actions: {
                backToList: 'Powrót do listy awarii',
                generateReport: 'Generuj raport Excel'
            },
            filters: {
                machine: 'Maszyny',
                createdFrom: 'Data rozpoczęcia awarii od:',
                createdTo: 'Data rozpoczęcia awarii do:',
                searchingMachines: 'Trwa wyszukiwanie...',
                machinesNoData: 'Nie znaleziono maszyn.'
            },
            table: {
                headers: {
                    machineName: 'Nazwa maszyny',
                    productionDepartment: 'Dział produkcyjny',
                    accidentDepartment: 'Dział awarii',
                    averageRepairTime: 'Średni czas naprawy',
                    averageTimeBetweenAccidents: 'Średni czas między awariami'
                },
                durationValue: '{hours}h {minutes}min'
            }
        },
        createDialog: {
            title: 'Zgłoś awarię',
            fields: {
                type: 'Typ awarii',
                department: 'Dział',
                softwareType: 'Rodzaj oprogramowania',
                softwareTypeNoData: 'Nie znaleziono rodzaju oprogramowania',
                machine: 'Maszyna',
                reportingPerson: 'Osoba zgłaszająca',
                costCenterNumber: 'MPK',
                description: 'Opis'
            },
            validations: {
                typeRequired: 'Proszę wybrać typ awarii.',
                departmentRequired: 'Proszę wybrać dział.',
                machineRequired: 'Proszę wybrać maszynę.',
                softwareTypeRequired: 'Proszę wybrać rodzaj oprogramowania.',
                descriptionRequired: 'Opis jest wymagany.'
            }
        },
        statusHistory: {
            title: 'Historia statusu',
            table: {
                headers: {
                    oldStatus: 'Status przed',
                    comment: 'Komentarz',
                    newStatus: 'Status po',
                    user: 'Komentujący',
                    createdAt: 'Data utworzenia'
                }
            }
        },
        details: {
            pageTitle: 'Awaria / Zarządzanie awarią',
            pageTitleWithId: 'Awaria / Zarządzanie awarią / {id}',
            actions: {
                backToList: 'Powrót do listy',
                assignToMe: 'Przypisz do mnie',
                changeStatus: 'Zmień Status',
                redirect: 'Przekieruj',
                accept: 'Zatwierdź',
                startFix: 'Rozpocznij usuwanie',
                safeMode: 'Tryb awaryjny',
                declaredFixTime: 'Czas usunięcia awarii'
            },
            sections: {
                details: 'Dane awarii',
                comments: 'Komentarze dla awarii'
            },
            fields: {
                type: 'Typ awarii',
                status: 'Status',
                statusWithAssignee: '{status} | {assignee}',
                machine: 'Maszyna',
                softwareType: 'Rodzaj oprogramowania',
                machineOrSoftware: 'Maszyna/Oprogramowanie',
                department: 'Dział',
                description: 'Opis'
            },
            comments: {
                noComments: 'Brak komentarzy dla awarii.',
                addLabel: 'Dodaj komentarz',
                send: 'Wyślij',
                subtitle: '{username} - {date}'
            },
            dialogs: {
                assignUser: {
                    title: 'Przypisanie awarii',
                    content: 'Przypisz awarię # {id} do {userName}'
                },
                assignStatus: {
                    title: 'Zmiana Statusu',
                    fields: {
                        status: 'Status',
                        statusPlaceholder: 'Wybierz status...',
                        statusNoData: 'Nie znaleziono statusu',
                        comment: 'Komentarz'
                    }
                },
                assignDepartment: {
                    title: 'Przekierowanie',
                    fields: {
                        department: 'Dział',
                        departmentNoData: 'Nie znaleziono działu'
                    }
                },
                declaredFixTime: {
                    title: 'Czas usunięcia awarii',
                    fields: {
                        minutes: 'minut'
                    }
                }
            },
            notifications: {
                safeModeSuccess: 'Ustawiono tryb awaryjny.',
                noPermissionDuringRemoval: 'Nie masz uprawnień by wykonać tę czynność.'
            }
        }
    },
    service: {
        fetchAccidentsError: 'Pobranie listy awarii nie powiodło się.',
        fetchAccidentError: 'Pobranie danych do awarii {accidentId} nie powiodło się.',
        fetchAccidentTypesError: 'Pobranie typów awarii nie powiodło się.',
        fetchAccidentStatusesError: 'Pobranie statusów nie powiodło się.',
        fetchAccidentStatusHistoryError: 'Pobranie historii statusów nie powiodło się.',
        fetchMachinesError: 'Pobranie maszyn nie powiodło się.',
        fetchSoftwareTypesError: 'Pobranie typów oprogramowania nie powiodło się.',
        fetchAccidentDepartmentsError: 'Pobranie działów nie powiodło się.',
        fetchAccidentUserDepartmentsError: 'Pobranie działów użytkownika nie powiodło się.',
        createAccidentSuccess: 'Awaria została dodana.',
        createAccidentError: 'Dodanie awarii nie powiodło się.',
        updateAccidentSuccess: 'Awaria została zedytowana.',
        updateAccidentError: 'Edycja awarii nie powiodła się.',
        deleteAccidentError: 'Usunięcie awarii nie powiodło się.',
        createAccidentCommentSuccess: 'Dodano komentarz.',
        createAccidentCommentError: 'Dodanie komentarza nie powiodło się.',
        generateAccidentsReportSuccess: 'Raport został wysłany na adres {userEmail}.',
        generateAccidentsReportError: 'Wygenerowanie raportu nie powiodło się.',
        generateAccidentDashboardReportSuccess: 'Raport dashboardu awarii został wysłany na adres {userEmail}.',
        generateAccidentDashboardReportError: 'Wygenerowanie raportu dashboardu awarii nie powiodło się.',
        fetchAccidentDashboardError: 'Pobranie danych dashboardu awarii nie powiodło się.',
        fetchAccidentDashboardMachinesError: 'Pobranie listy maszyn dashboardu nie powiodło się.'
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
